/**
 * Quick registration form layout script class
 *
 * @package    Layouts
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Link } from 'react-router-dom';
import Check from '@material-ui/icons/Check';
import { scrollerHandler } from 'Utils';

import {
    ContactInfoForm,
    ProfessionalInfoForm,
    IdsInfoForm,
    PasswordForm,
} from 'Components/FormGroup';

import Button from 'Common/CustomButtons/Button';

import styles from './styles.js';
import FormGroup from 'Components/FormGroup/FormGroup';

@withStyles(styles)
@reduxForm({
    form: 'quick_registration',
    enableReinitialize: true,
    onSubmitFail: scrollerHandler,
})
export default class QuickRegisterForm extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        submitting: PropTypes.bool.isRequired,
        invalid: PropTypes.bool.isRequired,
        initialValues: PropTypes.object,
        classes: PropTypes.object.isRequired,
    };

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    static consents = [
        { name: 'register', label: 'registration.consents.register' },
        { name: 'orcid', label: 'registration.consents.orcid' },
        { name: 'notifications', label: 'registration.consents.notifications' },
        { name: 'send_manuscript', label: 'registration.consents.send_manuscript' },
        { name: 'notifications_auth', label: 'registration.consents.notifications_auth' },
        { name: 'become_reviewer', label: 'registration.consents.become_reviewer' },
    ];

    /**
     * @type {Object}
     */
    state = {
        checked: [],
        errors: false,
    };

    handleSubmit = e => {
        e && e.preventDefault();

        const { handleSubmit, invalid } = this.props;
        const { checked } = this.state;

        if (checked.length < QuickRegisterForm.consents.length) {
            if (invalid) {
                handleSubmit();
            }

            this.setState({
                errors: true,
            });
        } else {
            handleSubmit();
        }
    };

    handleToggle = name => {
        const { checked } = this.state;
        const currentIndex = checked.indexOf(name);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(name);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        this.setState({
            checked: newChecked,
        });
    };

    isChecked = (name) => {
        const { checked } = this.state;
        return checked.indexOf(name) !== -1;
    };

    isDisabled = () => {
        const { submitting } = this.props;

        return submitting;
    };

    getPrivacyPolicyLink = () => {
        return (
            <Link to="/privacy-policy" target="_blank">
                Privacy Policy
            </Link>
        );
    };

    getFrontLink = () => {
        return (
            <Link to="//manuscript-adminsystem.com" target="_blank">
                manuscript-adminsystem.com
            </Link>
        );
    };

    render() {
        const { classes } = this.props;
        const { errors } = this.state;

        return (
            <form onSubmit={this.handleSubmit} id="quick_registration" className={classes.form}>
                <ContactInfoForm required />

                <ProfessionalInfoForm required exclude={['degree', 'faculty', 'department', 'university']}/>

                <IdsInfoForm exclude={['researcher_id']}/>

                <PasswordForm required />

                <FormGroup title="form_groups.consents"/>

                <div>
                    <FormattedMessage id="registration.consents.gdpr" values={{ link: this.getPrivacyPolicyLink() }} />
                </div>

                <div>
                    <FormattedMessage id="registration.consents.gdpr_subtitle" values={{ link: this.getFrontLink() }} />
                </div>

                {QuickRegisterForm.consents.map(checkbox => (
                    <div key={checkbox.name}>
                        <FormControlLabel
                            key={checkbox.name}
                            classes={{
                                root: classes.checkboxLabelControl,
                                label: classes[errors && !this.isChecked(checkbox.name) ? 'checkboxLabelError' : 'checkboxLabel'],
                            }}
                            control={
                                <Checkbox
                                    tabIndex={-1}
                                    onClick={() => this.handleToggle(checkbox.name)}
                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                    icon={<Check className={classes.uncheckedIcon} />}
                                    classes={{
                                        checked: classes.checked,
                                    }}
                                />
                            }
                            label={
                                <span>
                                    <FormattedMessage id={checkbox.label} />
                                </span>
                            }
                        />
                    </div>
                ))}

                <div className={classes.center + ' registerSubmit'}>
                    <Button round color="primary" disabled={this.isDisabled()} type="submit">
                        <FormattedMessage id="button.registration" />
                    </Button>
                </div>
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/QuickRegister/QuickRegisterForm.jsx